<template>

    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner :admin="false" />
    </b-container>

    <b-container v-else class="tt-container-main">

        <b-container class="tt-container-header">

            <b-row class="m-0 tt-row-header"> {{ header }} </b-row>

            <b-row class="m-0 gray roman">
                {{entity.MdRetailChainName}}
            </b-row>
        </b-container>

        <b-container class="p-0 mt-30">
            <b-tabs fill class="tabs-view-TT">

                <b-tab title="Информация">

                    <b-list-group class="shadow">

                        <b-list-group-item class="tt-list-item">

                            <info-edit :trade-point="entity" />

                        </b-list-group-item>

                        <b-list-group-item class="container-button">

                            <b-button variant="outline-primary" 
                                    class="button-blue"
                                    @click="updateTradePoint">
                                Продолжить
                            </b-button>

                        </b-list-group-item>

                    </b-list-group>

                </b-tab>

                <b-tab title="Контакты">

                    <b-list-group class="shadow">

                        <b-list-group-item class="tt-list-item">
                        
                            <dax-contacts-edit :options="entity.DaxContactList" />

                        </b-list-group-item>

                        <b-list-group-item class="container-button">

                            <b-button variant="outline-primary" 
                                    class="button-blue"
                                    @click="updateTradePoint">
                                Продолжить
                            </b-button>

                        </b-list-group-item>

                    </b-list-group>

                </b-tab>

            </b-tabs>
        </b-container>

    </b-container>
</template>
<script>
import dialogService from '@/services/dialog.service'

import AllRoutes from '@/routes/all.routes'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import YesNoInput from '@/components/shared/YesNoInput'
import InfoEdit from '@/components/client/tradePoints/edit/InfoEdit'
import DaxContactsEdit from '@/components/client/tradePoints/edit/DaxContactsEdit'

import TradePointEditModel from '@/store/models/client/tradePoints/TradePointViewEdit'

export default {
    computed: {
        header: function() {
            return this.$route.query.id
                        ? "Изменение торговой точки"
                        : "Создание торговой точки";
        }
    },
    data: function() {
        let load = new Loading();   

        let id = this.$route.query.id
                    ? this.$route.query.id
                    : null;

        let entity = {};

        if(!this.$route.query.id)
            entity = new TradePointEditModel(null);

        return {
            id: id,
            entity: entity,
            load: load,

            segments: [],
            viewSegments: []
        }
    },
    watch: {
        entity: {
            handler: function() {
                this.updateStorage();
            },
            deep: true
        }
    },
    created: function() {
            if(!this.$route.query.id)
                return;

            if(Object.keys(this.$route.params).length) {
                this.entity = this.$route.params.tradePointEdit;
                this.updateStorage();
            }                

            let storedTTEdit = this.getStorage();
            this.entity = new TradePointEditModel({ ...this.$route.params.tradePointEdit, ...storedTTEdit });           
    },
    methods: {
        getStorage: function() {
            return JSON.parse(localStorage.getItem('trade.point'));
        },
        setStorage: function(value) {
            localStorage.setItem('trade.point', JSON.stringify(value));
        },
        updateStorage: function() {
            let storedTTEdit = this.getStorage();
            if(!storedTTEdit) storedTTEdit = {};

            storedTTEdit = JSON.parse(JSON.stringify(this.entity));
            this.setStorage(storedTTEdit);
        },

        updateTradePoint: function() {
            if(!this.entity.isValidName()) {
                dialogService.showAlert('Прудпреждение', 'Вы не заполнили обязательное поле "Название"');
                return;
            }
            if(!this.entity.isValidSegment()) {
                dialogService.showAlert('Прудпреждение', 'Вы не заполнили обязательное поле "Сегмент"');
                return;
            }
            if(!this.entity.isValidType()) {
                dialogService.showAlert('Прудпреждение', 'Вы не заполнили обязательное поле "Категория торговой точки"');
                return;
            }

            if(this.entity.isInValidDaxContactsName() && this.entity.isInValidDaxContactsRights()) {
                dialogService.showAlert('Предупреждение', 'Вы не заполнили обязательные поля "ФИО", "Права" во вкладке "Контакты"');
                return;
            }

            if(this.entity.isInValidDaxContactsName()) {
                dialogService.showAlert('Предупреждение', 'Вы не заполнили обязательное поле "ФИО" во вкладке "Контакты"');
                return;
            }

            if(this.entity.isInValidDaxContactsRights()) {
                dialogService.showAlert('Предупреждение', 'Вы не заполнили обязательное поле "Права" во вкладке "Контакты"');
                return;
            }
            
            this.$router.push(AllRoutes.Client.TradePoints.View + `?auditId=${this.$route.query.auditId}`);
        }

    },    
    components: {
        Spinner,
        YesNoInput,
        InfoEdit,
        DaxContactsEdit
    }
}
</script>

<style>
.tt-edit-label {
    color: #bbbdbf;
    font-size: 14px;
    font-family: 'HelveticaNeueCyr-Roman';
}
</style>